import { countries } from '../helpers/countries';
import { provinces } from '../helpers/provinces';
import { applicantFields, peCoverageField,} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'rimisecureadvantageplus';
const org = 'rimi';

const dateLimits = {
  effective_date: {
    max: {
      base: ['application', 'sale_date'],
      offset: "+31 days"
    },
    min: 'today'
  }
};

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Agent'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName, dateLimits),
    fieldGroups.beneficiaryGroupWithEstate(clientName),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(true),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
    fieldGroups.attachmentGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [
      ...peCoverageField('0', org),
    ],
    dependent_fields: [
      ...applicantFields('*', [
          {value: 'dependent', text: 'Dependent'},
          {value: 'travelling companion', text: 'Travelling Companion'},
          {value: 'spouse', text: 'Spouse'}
        ]),
      ...peCoverageField('*', org),
    ],
    coverage_fields: [
      {
        key_path: ['application', 'additional_data', 'policy_type'],
        as: 'Policy Type',
        type: 'dropdown',
        options: [
          {value: 'option_1', text: 'Option 1 AD&D Benefit - $25,000'},
          {value: 'option_2', text: 'Option 2 AD&D Benefit - $50,000'},
        ],
        is_static_by_default: true
      },
      {
        key_path: ['application', 'additional_data', 'coverage'],
        as: 'Coverage',
        type: 'dropdown',
        options: [
          {value: 25000, text: '$25,000.00 CAD'},
        ],
        is_static_by_default: true
      },
      {
        key_path: ['application', 'expiry_date'],
        as: 'Renewal Date',
        type: 'date',
        format: 'date',
        min_date: 'value_of_field',
        is_static_by_default: true
      },
      {
        key_path: ['application', 'additional_data', 'billing_date'],
        as: 'Billing Date',
        type: 'date',
        format: 'date',
        show_only_when: 'view',
        min_date: 'value_of_field',
        do_not_show_if: [{
          key_path: [ 'application', 'additional_data', 'payment_option'],
          value: 'lumpsum'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'billing_date'],
        as: 'Update Billing Date',
        type: 'button',
        action: 'update_billing_date',
        show_only_when: 'edit',
        icon: 'fa fa-calendar',
        do_not_show_if: [{
          key_path: [ 'application', 'additional_data', 'payment_option'],
          value: 'lumpsum'
        }]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/clients/rimisecureadvantageplus.js